/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import localFont from 'next/font/local'

/** A local font for the Matter font family. */
export const matterFont = localFont({
  src: [
    {
      path: './fonts/Matter-Light.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: './fonts/Matter-LightItalic.woff2',
      weight: '300',
      style: 'italic',
    },
    {
      path: './fonts/Matter-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './fonts/Matter-RegularItalic.woff2',
      weight: '400',
      style: 'italic',
    },
    {
      path: './fonts/Matter-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: './fonts/Matter-MediumItalic.woff2',
      weight: '500',
      style: 'italic',
    },
    {
      path: './fonts/Matter-SemiBold.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: './fonts/Matter-SemiBoldItalic.woff2',
      weight: '600',
      style: 'italic',
    },
    {
      path: './fonts/Matter-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './fonts/Matter-BoldItalic.woff2',
      weight: '700',
      style: 'italic',
    },
    {
      path: './fonts/Matter-Heavy.woff2',
      weight: '900',
      style: 'normal',
    },
    {
      path: './fonts/Matter-HeavyItalic.woff2',
      weight: '900',
      style: 'italic',
    },
  ],
  preload: false,
  fallback: ['system-ui', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Arial', 'sans-serif'],
  display: 'swap',
})
